import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import './AnnouncementBanner.css';

const API_URL = process.env.REACT_APP_API_URL;

const AnnouncementBanner = ({ onVisibilityChange }) => {
    const { i18n } = useTranslation();
    const [banner, setBanner] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    // DÜZELTME 1: Veri çekme mantığı useCallback içine alındı
    const fetchBanner = useCallback(async () => {
        try {
            const response = await fetch(`${API_URL}/api/public/active-banner?lang=${i18n.language}`);
            if (response.ok) {
                const data = await response.json();
                
                // Gelen veriyi konsola yazdırarak kontrol edelim
                console.log("Fetched Banner Data:", data);

                if (data && !sessionStorage.getItem(`banner_closed_${data.id}`)) {
                    setBanner(data);
                    setIsVisible(true);
                } else {
                    // Eğer veri null ise veya banner zaten kapatılmışsa, gizle
                    setIsVisible(false);
                }
            }
        } catch (error) {
            console.error("Banner alınamadı:", error);
            setIsVisible(false);
        }
    }, [i18n.language]); // Sadece dil değiştiğinde fonksiyon yeniden oluşur

 useEffect(() => {
        onVisibilityChange(isVisible);
    }, [isVisible, onVisibilityChange]);
    // DÜZELTME 2: useEffect artık daha sağlam
    useEffect(() => {
        fetchBanner();
    }, [fetchBanner]); // fetchBanner her değiştiğinde (yani dil değiştiğinde) çalışır

    const handleClose = () => {
        setIsVisible(false);
        if (banner) {
            sessionStorage.setItem(`banner_closed_${banner.id}`, 'true');
        }
    };

    if (!isVisible || !banner) return null;

    return (
        <div className="announcement-banner">
            <div className="banner-content">
                <ReactMarkdown>{banner.content}</ReactMarkdown>
                {banner.buttonText && banner.buttonLink && (
                    <a href={banner.buttonLink} className="banner-button">{banner.buttonText}</a>
                )}
            </div>
            <button onClick={handleClose} className="banner-close-btn">&times;</button>
        </div>
    );
};

export default AnnouncementBanner;